<template>
  <div>
    <div v-if="isLoading">
      <v-progress-circular indeterminate size="30"></v-progress-circular>
    </div>
    <h2 v-else-if="allTests.length == 0">No Tests Found</h2>
    <div v-for="test in allTests" :key="test.id" v-else>
      <TestListItem :test="test" @refreshList="$emit('refreshList')" @deleteTest="(test) => $emit('deleteTest', test)" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TestListItem from "./TestListItem.vue";

export default {
  name: "TestList", 
  props: ["allTests", "isLoading"],
  data() {
    return {};
  },
  components: {
    TestListItem
  },
  computed: {
    ...mapGetters(["currentUser", "adminRoom"])
  },

};
</script>

<style scoped>
.space-right {
  margin-right: 10px;
}
.add-test{ 
  display: none;
}
</style>